export default __webpack_public_path__ + "static/media/Support_Carrier-Grade-Support.c7b93acd.mp4";